import { render, staticRenderFns } from "./Workwithus.vue?vue&type=template&id=4afdd9fc&scoped=true&"
import script from "./Workwithus.vue?vue&type=script&lang=js&"
export * from "./Workwithus.vue?vue&type=script&lang=js&"
import style0 from "./Workwithus.vue?vue&type=style&index=0&id=4afdd9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afdd9fc",
  null
  
)

export default component.exports